import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RestTmtService } from './rest-tmt.service';
import { HttpClient } from '@angular/common/http';

registerLocaleData(localeIt, 'it');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeNl, 'nl');

/**ToDo Documentazione */
@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(public translateService: TranslateService, service: RestTmtService, private http: HttpClient) {
    translateService.addLangs(['en', 'fr', 'it', 'nl']);
    const client = service.getClient();
    let defaultLanguage = client.defaultLanguage;

    const savedLanguage = localStorage.getItem('selectedLanguage');

    if (savedLanguage) {
      defaultLanguage = savedLanguage;
    } else {
      if (client.consolidator === 'USAT') {
        const browserLang = (navigator.language || '').toLowerCase();
        const browserLangs = (navigator.languages || []).map(l => l.toLowerCase());
        const isFrenchVisitor = browserLang.startsWith('fr') || browserLangs.some(l => l.startsWith('fr'));
        defaultLanguage = isFrenchVisitor ? 'fr' : 'nl';
      }
    }

    translateService.setDefaultLang(defaultLanguage);
    translateService.use(defaultLanguage).subscribe(() => {
      const customTranslationsUrl = `assets/custom/${client.consolidator}/i18n/custom.${defaultLanguage}.json`;
      this.http.get(customTranslationsUrl).subscribe((customTranslations: any) => {
        translateService.setTranslation(defaultLanguage, customTranslations, true);
      });
    });

    service.loadStyleTenant();
  }
}
